import { render, staticRenderFns } from "./VarietyInformation.vue?vue&type=template&id=42f64cb4&scoped=true&"
import script from "./VarietyInformation.vue?vue&type=script&lang=js&"
export * from "./VarietyInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f64cb4",
  null
  
)

export default component.exports